<button type="button" class="btn btn-link child-label-btn">
    <span *ngIf="showCloseIcon" class="child-label-btn__icon">
      <fa-icon [icon]="['fas', 'times']"></fa-icon>
    </span>
  <span class="label_text_max">{{ childAge }}</span>
  <span class="label_text_min">
      {{ 'TouristsComponent.ChildAgeLabel' | translate:{ count: childAge } }}
    </span>
</button>
